/**
 * Формирует SEO-заголовок и описание страницы новости.
 *
 * @param title - отображаемый заголовок новости
 * @returns SEO-данные страницы новости
 */
export const createNewsDetailSeo = (title: string) => ({
  title: `${title} - Farfor`,
  description: `Больше новостей от Farfor - ${title}`,
})
